import React from 'react'
import {
  Paper,
  TableContainer,
  TableRow,
  TableBody,
  TableCell,
  Table
} from '@mui/material'

interface PickingRouteDetailProps {
  sku: string
  qty: string
  ot: string
}

export const PickingRouteDetail: React.FC<PickingRouteDetailProps> = ({
  sku,
  qty,
  ot
}) => {
  return (
    <TableContainer component={Paper}>
      <Table size='small' aria-label='a dense table'>
        <TableBody>
          <TableRow key='sku'>
            <TableCell component='th' scope='row'>
              SKU
            </TableCell>
            <TableCell align='right'>{sku}</TableCell>
          </TableRow>
          <TableRow key='ean'>
            <TableCell component='th' scope='row'>
              QTY
            </TableCell>
            <TableCell align='right'>{qty}</TableCell>
          </TableRow>
          <TableRow key='qty'>
            <TableCell component='th' scope='row'>
              OT
            </TableCell>
            <TableCell align='right'>{ot}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
